import i18n from '@/i18n'
import { layoutDefaultColors, QueueChartColors } from '@/enum/colors'

export const activeCallColumns = [ {
    prop: 'QueueName',
    fixed: false,
    align: 'center',
    label: 'queue.queueName',
    sortable: true,
    resizable: true
}, {
    prop: 'QueueID',
    fixed: false,
    align: 'center',
    label: 'queue.queueID',
    sortable: true,
    resizable: true
}, {
    prop: 'CallerName',
    fixed: false,
    align: 'center',
    label: 'queue.callerName',
    sortable: true,
    resizable: true
}, {
    prop: 'CallerID',
    fixed: false,
    align: 'center',
    label: 'CallerID',
    sortable: true,
    resizable: true
}, {
    prop: 'WaitingTime',
    fixed: false,
    align: 'center',
    label: 'queue.waitingTime',
    sortable: true,
    resizable: true
} ]

export const activeGaugeCallColumns = [ {
    prop: 'Id',
    fixed: false,
    align: 'center',
    label: '#',
    sortable: false
}, {
    prop: 'QueueID',
    fixed: false,
    align: 'center',
    label: 'queue.queueID',
    sortable: true,
    resizable: true
}, {
    prop: 'CallerID',
    fixed: false,
    align: 'center',
    label: 'CallerID',
    sortable: false
}, {
    prop: 'WaitingTime',
    fixed: false,
    align: 'center',
    label: 'Waiting Time',
    sortable: false
}, {
    prop: 'QueueName',
    fixed: false,
    align: 'center',
    label: 'Queue Name',
    sortable: false
} ]

export const DEFAULT_CHART_SERIES_LINES_KEYS = {
    MAX_WAITING_TIME: {
        key: 'MAX_WAITING_TIME',
        serieType: 'line',
        name: i18n.global.t('call.maxWaitingTime'),
        layoutColorVar: '',
        colorVar: 'maxWaitingTime',
        colorDefault: QueueChartColors.maxWaitingTime
    },
    QUEUE_CALLS: {
        key: 'QUEUE_CALLS',
        serieType: 'line',
        name: i18n.global.t('call.queueCalls'),
        layoutColorVar: '',
        colorVar: 'queueCalls',
        colorDefault: QueueChartColors.queueCalls
    },
    AGENTS_ON_HOLD: {
        key: 'AGENTS_ON_HOLD',
        serieType: 'column',
        name: i18n.global.t('status.hold'),
        layoutColorVar: 'onHold',
        colorVar: '',
        colorDefault: layoutDefaultColors.onHold
    },
    AGENTS_IN_CALL: {
        key: 'AGENTS_IN_CALL',
        serieType: 'column',
        name: i18n.global.t('status.incall'),
        layoutColorVar: 'inCall',
        colorVar: '',
        colorDefault: layoutDefaultColors.inCall
    }
}

export const getAllSeries = (accountStatuses) => {
    return [
        ...Object.values(DEFAULT_CHART_SERIES_LINES_KEYS).map(DEFAULT_CHART_SERIE => {
            return {
                value: DEFAULT_CHART_SERIE.key,
                label: DEFAULT_CHART_SERIE.name
            }
        }),
        ...accountStatuses.map(accountStatus => {
            return {
                value: accountStatus.StatusID,
                label: accountStatus.Name
            }
        })
    ]
}
